const t = "size-4 shrink-0 [&_path]:fill-current";
export {
  t as DEFAULT_ICON_CLASS_NAME
};
